<div class="pdf-page app-aul-013-24" id="texas1324">
  <!-- <app-policy-header></app-policy-header> -->
  <br />
  <p class="font-large" style="text-align: center">
    <b>AMENDATORY ENDORSEMENT</b>
  </p>
  <p class="font-large" style="text-align: center"><b>TEXAS CHANGES</b></p>
  <p class="font-large" style="text-align: center">
    <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ CAREFULLY</b>
  </p>
  <p class="font-medium">
    <b>
      This endorsement comprising of policyholder notices, coverage changes and
      endorsements attaches to and forms part of the policy numbered
      {{ this.policyDetails?.policyNo }}
    </b>
  </p>
  <br />
  <p class="font-medium" style="text-decoration: underline">
    <b><u>SURPLUS LINES DISCLOSURE NOTICE</u></b>
  </p>
  <p class="font-medium" style="text-align: justify; width: 95%;">
    <b
      >THIS INSURANCE CONTRACT IS WITH AN INSURER NOT LICENSED TO TRANSACT
      INSURANCE IN THIS STATE AND IS ISSUED AND DELIVERED AS SURPLUS LINE
      COVERAGE UNDER THE TEXAS INSURANCE STATUTES. THE TEXAS DEPARTMENT OF
      INSURANCE DOES NOT AUDIT THE FINANCES OR REVIEW THE SOLVENCY OF THE
      SURPLUS LINES INSURER PROVIDING THIS COVERAGE, AND THE INSURER IS NOT A
      MEMBER OF THE PROPERTY AND CASUALTY INSURANCE GUARANTY ASSOCIATION CREATED
      UNDER CHAPTER 462, INSURANCE CODE. CHAPTER 225, INSURANCE CODE, REQUIRES
      PAYMENT OF A 4.85 PERCENT TAX ON GROSS PREMIUM. A SURPLUS LINES DOCUMENT
      MUST SHOW:
    </b>
  </p>
  <ol type="1" start="1" class="font-medium" style="font-weight: bold;">
    <li>
      <p>THE DESCRIPTION AND LOCATION OF THE SUBJECT OF THE INSURANCE;</p>
    </li>
    <li>
      <p>THE COVERAGE, CONDITIONS, AND TERM OF THE INSURANCE;</p>
    </li>
    <li>
      <p>
        THE PREMIUM AND RATE CHARGED, AND PREMIUM TAXES TO BE COLLECTED FROM THE
        INSURED;
      </p>
    </li>
    <li>
      <p>THE NAME AND ADDRESS OF:</p>
      <div>
        <p><span>A. </span> THE INSURED;</p>
        <p><span>B. </span> THE INSURER; AND</p>
        <p>
          <span>C. </span> THE INSURANCE AGENT WHO OBTAINED THE SURPLUS LINE
          COVERAGE; AND;
        </p>
      </div>
    </li>
    <li>
      <p>IF THE DIRECT RISK IS ASSUMED BY MORE THAN ONE INSURER:</p>
      <div>
        <p><span>A. </span> THE NAME AND ADDRESS OF EACH INSURER; AND;</p>
        <p>
          <span>B. </span> THE PROPORTION OF THE ENTIRE DIRECT RISK ASSUMED BY
          EACH INSURER.
        </p>
      </div>
    </li>
  </ol>
  </div>
  <div class="pdf-page app-aul-013-24">
    <div>
      <p class="font-medium">
        <b
          ><span style="text-decoration: underline"
            >SERVICE OF SUIT CLAUSE</span
          ></b
        >
      </p>
    </div>
    <div>
      <p class="font-medium">
        <u>FORTEGRA SPECIALTY INSURANCE COMPANY</u>
      </p>
    </div>
    <ol style="padding-left: 12px" type="I">
      <li style="padding-bottom: 10px;">
        We may be sued on any cause of action arising in Texas under any surplus
        lines insurance contract issued by us or under any certificate, cover
        note, or other confirmation of that insurance issued by the surplus
        lines agent, under the same procedure as is provided for unauthorized
        insurers in Sections 7.1404, 7.1410, and 7.1411 of Title 28 of the Texas
        Administrative Code (relating to Service of Process Procedure for
        Domestic Insurers Approved To Operate under the Insurance Code, Article
        1.28, Foreign and Alien Insurance Companies, Risk Retention Groups,
        Purchasing Groups, Third Party Administrators, Unauthorized Persons or
        Insurers, Organizations Formed under the Insurance Code, Article 3.71,
        and Surplus Lines Insurers; Service of Process on Commissioner on Behalf
        of Unauthorized Persons or Insurers; and Service of Process, Notice,
        Order, or Pleading on Secretary of State on Behalf of Unauthorized
        Persons and Insurers). By assuming a surplus lines risk under Chapter
        981 of the Texas Insurance Code, we are subject to Tex. Ins. Code Ann. §
        804.106. Any act of engaging in the business of insurance by us, an
        eligible surplus lines insurer, constitutes the irrevocable appointment
        by us of the Texas Secretary of State as agent for service of process
        arising from our engagement of the business of insurance in Texas, other
        than service of process for an action or proceeding by the department or
        state, and signifies our agreement that service under Tex. Ins. Code
        Ann. § 804.106 has the same effect as personal service on us or our
        successor in interest. The plaintiff shall supply the address provided
        in Section II of this Endorsement in any citation served under Tex. Ins.
        Code Ann. § 804.106. Service of process as set forth in this Endorsement
        is in addition to any other method provided by law for service of
        process on a surplus lines insurer, including the method provided by
        Chapter 804, Subchapter C of the Texas Insurance Code.
      </li>
      <li>
        All lawful process may be served in any action, suit or proceeding
        instituted by, or on behalf of, you or any beneficiary under this
        policy, against us arising out of this policy, upon:
        <br />
        <p>
          <b>Fortegra Specialty Insurance Company</b><br />
          <b>Corporate Creations Network Inc.</b><br />
          <b>5444 Westheimer #1000</b><br />
          <b>Houston, TX 77056</b><br />
          <b>Harris County</b><br />
          <b>Phone: (561) 694-8107</b><br />
        </p>
      </li>
    </ol>
    <p class="font-small">
      ALL OTHER TERMS, CONDITIONS, PROVISIONS AND EXCLUSIONS OF THIS POLICY
      REMAIN THE SAME.
    </p>
    <p class="font-small">FSIC TX SOS 01 25</p>
  </div>
